document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  new WOW().init()

  jQuery('.sp-scroll').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 35,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })

  new Swiper('.sp-swiper1', {
    speed: 5000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
  })

  new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
  })

  new Swiper('.sp-swiper4', {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
  })

  new Swiper('.sp-swiper-fade', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })

  new Swiper('.sp-swiper-fade1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find('.sp-text').each(function () {
          this.style.animation = 'none'
        })
        const spText = e.slides.eq(e.activeIndex).find('.sp-text')[0]
        if (spText) {
          spText.style.animation = 'none'

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`
        }
      },
    },
  })

  new Swiper('.sp-swiper0', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            if (dataSrc) {
              image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            }
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    // 准备图片数组 - 总共8张图片（sp-color有4个选项，sp-type有2个选项，4*2=8）
    let imgList = []
    for (let i = 1; i <= 14; i++) {
      imgList.push(
        `https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20260119-p${i}.png`
      )
    }
    let typeList = [
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601301-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601302-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601303-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601304-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601305-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601306-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601307-pro.png'
    ]
    let qtyIndexPinkTimes1 = [
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601308-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601312-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601316-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601320-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601324-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601328-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601332-pro.png'
    ]
    let qtyIndexBlueTimes1 = [
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601309-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601313-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601317-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601321-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601325-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601329-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601333-pro.png'
    ]
    let qtyIndexPinkTimes3 = [
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601310-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601314-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601318-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601322-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601326-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601330-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601334-pro.png'
    ]
    let qtyIndexBlueTimes3 = [
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601311-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601315-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601319-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601323-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601327-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601331-pro.png',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/202601335-pro.png'
    ]
    // let qtyIndexBlueTimes4 = [
    //   'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/lQLPM5HaIGJo5S3NARXNAyCwieaWKUhP_BUJWQFpEQ2ZAA_800_277.png?v=1770026825',
    //   'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/lQLPM4cpdPpH1S3NASLNAyCwm-RoU3zQqp0JWQFpcVDcAA_800_290.png?v=1770026825',
    //   'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/lQLPM5vwLprjNi3NAR_NAyCwoCxcsvi6stEJWQFpshuYAA_800_287.png?v=1770026825',
    //   'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/lQLPM465xXD3xi3NASTNAyCwh6zvIEuWQ7QJWQFp8tefAA_800_292.png?v=1770026825',
    //   'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/lQLPM33RfGh7Vi3NASXNAyCwLaTcNls9OLsJWQFqNFYzAA_800_293.png?v=1770026825',
    //   'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/lQLPM44C9oFUFy3NASXNAyCwRH1zEzqL3rYJWQFqkGbMAA_800_293.png?v=1770026825',
    //   'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/lQLPM53tf8nsFy3NASPNAyCwlsn9Z5JA0BcJWQFq3ykqAA_800_291.png?v=1770026825'
    // ]
    let qtyIndexBlueTimes4 = [
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__1.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__3.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__5.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__4.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__2.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__6.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__7.png?v=1772446557',
    ]
    let qtyIndexBlueTimes5 = [
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__9.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__13.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__10.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__11.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__14.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__12.png?v=1772446557',
      'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260302_img__8.png?v=1772446557',
    ]
    // 预加载所有图片
    preloadImages(imgList)
    preloadImages(typeList)
    preloadImages(qtyIndexPinkTimes1)
    preloadImages(qtyIndexPinkTimes3)
    preloadImages(qtyIndexBlueTimes1)
    preloadImages(qtyIndexBlueTimes3)
    preloadImages(qtyIndexBlueTimes4)
    preloadImages(qtyIndexBlueTimes5)
    // 更新主图显示
    function updateMainImage() {
      let colorIndex = $('#sp-color .sp-option.active').index()
      let typeIndex = $('#sp-type .sp-option.active').index()
      let qtyIndex = $('#sp-qty .sp-option.active').index()
      // 计算图片索引：sp-color的index + sp-type的index * 4
      let imgIndex = colorIndex 
      if(typeIndex === 0 && qtyIndex === 0) {
      

      // 更新图片
      $('.sp-img-p').attr('src', imgList[imgIndex])
      } 
      if(qtyIndex === 0 && typeIndex === 1 ) {
      $('.sp-img-p').attr('src', typeList[imgIndex])
      }
      if(qtyIndex === 1 && typeIndex === 0) {
      $('.sp-img-p').attr('src', qtyIndexPinkTimes1[imgIndex])
      }
      if(qtyIndex === 1 && typeIndex === 1) {
      $('.sp-img-p').attr('src', qtyIndexPinkTimes3[imgIndex])
      }
      if(qtyIndex === 2 && typeIndex === 0) {
      $('.sp-img-p').attr('src', qtyIndexBlueTimes1[imgIndex])
      }
      if(qtyIndex === 2 && typeIndex === 1) {
      $('.sp-img-p').attr('src', qtyIndexBlueTimes3[imgIndex])
      }
      if(qtyIndex === 3 && typeIndex === 0) {
        $('.sp-img-p').attr('src', qtyIndexBlueTimes4[imgIndex])
      }
      if(qtyIndex === 3 && typeIndex === 1) {
        $('.sp-img-p').attr('src', qtyIndexBlueTimes5[imgIndex])
      }
    }

    // 数量选项点击事件（sp-color）
    $('.sp-option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      updateMainImage()
      changePrice();
    })

    // 初始化图片
    updateMainImage()

    // IOS字体多了间距的处理
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent)

    if (!isAndroid && !isIOS && !isPC) {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]')
    if (!link) return

    event.preventDefault()

    const targetElement = document.getElementById('shopping')
    if (targetElement) {
      const offsetTop = targetElement.offsetTop
      let sptop = document.body.clientWidth <= 1080 ? 50 : 60
      let zoomValue = parseFloat($('div#root').css('zoom')) || 1
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth',
      })

      setTimeout(() => {
        if (
          window.pageYOffset === 0 ||
          Math.abs(window.pageYOffset - scrollTop) > 100
        ) {
          $('html, body').animate(
            {
              scrollTop: scrollTop,
            },
            800
          )
        }
      }, 100)
    }
  }

  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick)

  let sp_price1 = 8.99
  let sp_price2 = 24.99

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }
  let prods = window.product;
  function getCur() {
  let color = $("#sp-color div.active").attr("data-val");
  let type = $("#sp-type .sp-option.active").attr("data-val");
  let qty = $("#sp-qty .sp-option.active").attr("data-val");
  return prods.filter((item) => item.option1 == color && item.option2 == type && item.option3 == qty)[0];
  }
  function changePrice() {
  let num = $("#calcNumber").val();
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $("#sp_price1 span").html(price);
  $("#sp_price2 span").html(compare);
  let off_font =
  100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100);
  $(".font-off").html(off_font);
  }

  $('.sp-btn-style').click(function(){
      let num = $('#calcNumber').val()
      let id = getCur().id
      window.location.href = '/cart/' + id + ':' + num
  })
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
  changePrice()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
      changePrice()
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span, div')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span/div 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    $('.sp-menu-mask').hide()
  })

  function getZoomValue() {
    let zoom = $('div#root').css('zoom')
    return parseFloat(zoom) || 1
  }

  function handleScroll() {
    // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // let zoomValue = getZoomValue();
    // let headerHeight = $(".header:visible").height() * zoomValue;
    // if (scrollTop > headerHeight) {
    //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
    // } else {
    //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
    // }
  }

  // 初始检查
  handleScroll()

  // 监听多种滚动事件
  window.addEventListener('scroll', handleScroll, true)
  document.addEventListener('scroll', handleScroll, true)

  $(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060
    }

    // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      if (isMobile()) {
        $('.sp-mobile .sp-cart .num').show()
        $('.sp-mobile .sp-cart').addClass('on')
        setTimeout(function () {
          $('.sp-mobile .sp-cart').removeClass('on')
        }, 500)
      } else {
        $('.sp-pc .sp-header-top .sp-cart .num').show()
        $('.sp-pc .sp-header-top .sp-cart').addClass('on')
        setTimeout(function () {
          $('.sp-pc .sp-header-top .sp-cart').removeClass('on')
        }, 500)
      }
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
    })

    let initNum = 0

    $('.product-part .cart-btn').click(function () {
      let spNum = $('#calcNumber')[0].value
      initNum += Number(spNum)
          var data = {
    id: getCur().id,
    quantity: $('#calcNumber').val(),
  };
  // var img = $(".product-part .swiper-slide-active .sp-img");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
             $(".cardNum").each(function() {
                $(this).html(result.item_count)
                $(this).removeClass('sp-gray')
             })
        //   $(".cardNum").html(result.item_count);
        //   $('#cardNum').html(initNum)
//   $('.cardNum').removeClass('sp-gray')
        });
      },
      dataType: "json",
    });
    //   // 更新购物车数量
    //   if (isMobile()) {
    //     $('.sp-mobile .cardNum').each(function () {
    //       $(this).html(initNum)
    //     })
    //   } else {
    //     $('.sp-pc .cardNum').each(function () {
    //       $(this).html(initNum)
    //     })
    //   }
    //   $('.cardNum').removeClass('sp-gray')

      var imgs = $('.sp-img-p.active')

      imgs.each(function () {
        var $img = $(this)
        var flyer = $img[0].cloneNode(true)
        flyer.classList.add('sp_clone')

        $('.product-part').append(flyer)
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: '#e7e9ef',
          position: 'fixed',
          top: $img[0].offsetTop,
          left: $img.offset().left,
          'z-index': 99,
        })

        let finish, targetTop, targetLeft

        if (isMobile()) {
          // 移动端：飞向底部固定按钮中的购物车
          finish = $('.sp-btn-style2.sp-mobile .sp-cart')
          if (finish.length > 0) {
            targetTop = $('.sp-btn-style2')[0].offsetTop
            targetLeft =
              $('.sp-btn-style2 .sp-cart')[0].offsetLeft + finish.width() / 2
          } else {
            targetTop = 0
            targetLeft = 0
          }
        } else {
          // PC端：飞向header中的购物车
          finish = $('.sp-pc .sp-cart')
          if (finish.length > 0) {
            targetTop = finish[0].offsetTop + 20
            targetLeft = finish[0].offsetLeft
          } else {
            targetTop = 0
            targetLeft = 0
          }
        }

        $(flyer).animate(
          {
            top: targetTop,
            left: targetLeft,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      })
    })
  })

  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
})

function handleScroll() {
  var scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0

  var header = document.querySelector('#sp-header.sp-pc .header-inner')
  if (header) {
    if (scrollTop > 100) {
      header.classList.add('sp-fixed')
    } else {
      header.classList.remove('sp-fixed')
    }
  }
}

window.addEventListener('scroll', handleScroll, true)
